import type { RouterConfig } from '@nuxt/schema';

// https://router.vuejs.org/api/interfaces/routeroptions.html#scrollbehavior
export default <RouterConfig>{
  scrollBehaviorType: 'smooth',

  scrollBehavior(to, from, savedPosition) {
    const nuxtApp = useNuxtApp();

    const waitAndScroll = (scrollOptions: any) => {
      return new Promise((resolve) => {
        nuxtApp.hooks.hookOnce('page:finish', () => {
          resolve(scrollOptions);
        });
      });
    };

    if (!from.name && to.hash) {
      return waitAndScroll({ el: to.hash, behavior: 'auto' });
    }

    // 1. If a saved position exists (like hitting the 'Back' button), restore it
    if (savedPosition) {
      return waitAndScroll(savedPosition);
    }

    // 2. If the URL has a hash (e.g., #about-us)
    if (to.hash) {
      const hashOptions = {
        el: to.hash,
        behavior: 'smooth',
      };

      if (to.path === from.path) {
        return hashOptions;
      }

      return waitAndScroll(hashOptions);
    }

    // 3. Scroll to top for different pages
    if (to.path !== from.path) {
      return waitAndScroll({ top: 0 });
    }

    // 4. Default: Scroll to top on current page if no hash
    return { top: 0, behavior: 'smooth' };
  },
};
